var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("代购会员端语言包转换")]),_c('input',{attrs:{"type":"file"},on:{"change":_vm.uploadExcelFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }